// Collapse message markdown to the sentence a preview (a notification, an alert row) reads as.
// TWIN: collapseMessageMarkdown in packages/server/src/server/cyborg/message-push-preview.ts is an
// exact mirror; change both together (packages/ui stays decoupled from packages/server).

// Step order is load-bearing: fenced code first (its `#`/`-` are no headings or bullets); only an
// autolink loses `<...>` ("Array<string>" must survive); images before links (both grammars take
// backslash escapes); emphasis unwraps only when its markers hug the text, so "2 * 3 = 6" and
// "foo_bar_baz" keep their characters. An image is remembered so the caller can label it.
export function collapseMessageMarkdown(raw: string): {
  text: string;
  imageAlt: string | null;
  hadImage: boolean;
} {
  let out = raw.replace(/```[A-Za-z0-9_+.-]*[ \t]*\r?\n?([\s\S]*?)```/g, " $1 ");
  out = out.replace(/```/g, " "); // an unterminated fence leaves a stray marker
  out = out.replace(/`([^`\n]+)`/g, "$1");
  out = out.replace(/<((?:https?|mailto):[^>\s]+)>/g, "$1");
  const unescapeMarkdown = (s: string): string => s.replace(/\\(.)/g, "$1");
  const imageAlts: string[] = [];
  out = out.replace(/!\[((?:\\.|[^\]\\])*)\]\((?:\\.|[^)\\])*\)/g, (_m, alt: string) => {
    imageAlts.push(unescapeMarkdown(alt));
    return " ";
  });
  out = out.replace(/\[((?:\\.|[^\]\\])*)\]\((?:\\.|[^)\\])*\)/g, (_m, label: string) =>
    unescapeMarkdown(label),
  );
  out = out.replace(/^[ \t]{0,3}>[ \t]?/gm, "");
  out = out.replace(/^[ \t]{0,3}#{1,6}[ \t]+/gm, "");
  out = out.replace(/^[ \t]{0,3}(?:[-*+]|\d{1,3}[.)])[ \t]+/gm, "");
  out = out.replace(/^[ \t]{0,3}(?:[-*_][ \t]*){3,}$/gm, " ");
  out = out.replace(/\*\*(?![\s*])([^*]*[^\s*])\*\*/g, "$1");
  out = out.replace(/(?<!\*)\*(?![\s*])([^*\n]*[^\s*])\*(?!\*)/g, "$1");
  out = out.replace(/~~(?![\s~])([^~]*[^\s~])~~/g, "$1");
  out = out.replace(/(?<!\w)_(?![\s_])([^_\n]*[^\s_])_(?!\w)/g, "$1");
  const firstAlt = (imageAlts[0] ?? "").trim();
  return {
    text: out.replace(/\s+/g, " ").trim(),
    imageAlt: firstAlt.length > 0 ? firstAlt : null,
    hadImage: imageAlts.length > 0,
  };
}
